__turbopack_context__.v({
  "arrowWrap": "ClothesLine-module__HKCVra__arrowWrap",
  "innerWrap": "ClothesLine-module__HKCVra__innerWrap",
  "link": "ClothesLine-module__HKCVra__link",
  "linkActive": "ClothesLine-module__HKCVra__linkActive" + " " + "ClothesLine-module__HKCVra__link",
  "list": "ClothesLine-module__HKCVra__list",
  "outerWrap": "ClothesLine-module__HKCVra__outerWrap",
  "progress": "ClothesLine-module__HKCVra__progress",
  "scrollArrow": "ClothesLine-module__HKCVra__scrollArrow",
  "title": "ClothesLine-module__HKCVra__title",
});
